(() => {
  'use strict';
  const root = document.querySelector('[data-monolith-advisors]');
  const view = root?.querySelector('[data-advisor-view="shop"]');
  if (!view) return;
  const copy = {
    de:['Im Chat entdecken','Schau dich in Ruhe um. Wische über das Bild oder nutze die Pfeile – deine Beratung bleibt hier.','Pinsel','Primer','Singles','Zurück zur Beratung','Produkte werden geladen …','Hier sind gerade keine verfügbaren Produkte.','Das Laden hat gerade nicht geklappt. Bitte versuche es nochmals.','Nochmals laden','Vorherige Produkte','Nächste Produkte','{n} von {total}','Kurze Produktinfos','Produktseite öffnen','Kategorie in neuem Tab öffnen','Weitere Produkte laden','Preise und Verfügbarkeit können sich ändern. Die Produktseite zeigt die vollständigen Angaben.'],
    en:['Explore in the chat','Take your time. Swipe the image or use the arrows – your advice stays here.','Brushes','Primers','Singles','Back to your advice','Loading products …','No products are available here right now.','Products could not be loaded. Please try again.','Try again','Previous products','Next products','{n} of {total}','Quick product details','Open product page','Open collection in a new tab','Load more products','Prices and availability may change. The product page has the full details.'],
    fr:['Découvrir dans le chat','Prenez votre temps. Balayez l’image ou utilisez les flèches : vos conseils restent ici.','Pinceaux','Primers','Fards individuels','Retour aux conseils','Chargement des produits…','Aucun produit disponible ici pour le moment.','Le chargement a échoué. Veuillez réessayer.','Réessayer','Produits précédents','Produits suivants','{n} sur {total}','Infos produit en bref','Ouvrir la fiche produit','Ouvrir la collection dans un nouvel onglet','Charger d’autres produits','Les prix et la disponibilité peuvent changer. Consultez la fiche produit pour les détails complets.'],
    it:['Scopri nella chat','Prenditi il tuo tempo. Scorri sull’immagine o usa le frecce: i consigli restano qui.','Pennelli','Primer','Ombretti singoli','Torna ai consigli','Caricamento prodotti…','Al momento non ci sono prodotti disponibili qui.','Impossibile caricare i prodotti. Riprova.','Riprova','Prodotti precedenti','Prodotti successivi','{n} di {total}','Informazioni in breve','Apri la pagina prodotto','Apri la collezione in una nuova scheda','Carica altri prodotti','Prezzi e disponibilità possono cambiare. La pagina prodotto contiene le informazioni complete.'],
    es:['Descubre en el chat','Tómate tu tiempo. Desliza sobre la imagen o usa las flechas: los consejos siguen aquí.','Pinceles','Primers','Sombras individuales','Volver a los consejos','Cargando productos…','Ahora mismo no hay productos disponibles aquí.','No se pudieron cargar los productos. Inténtalo de nuevo.','Reintentar','Productos anteriores','Productos siguientes','{n} de {total}','Información breve','Abrir página del producto','Abrir colección en otra pestaña','Cargar más productos','Los precios y la disponibilidad pueden cambiar. Consulta la página del producto para ver todos los detalles.'],
    pl:['Odkrywaj w czacie','Nie spiesz się. Przesuwaj po zdjęciu lub używaj strzałek – porady pozostają tutaj.','Pędzle','Bazy','Pojedyncze cienie','Wróć do porad','Wczytywanie produktów…','Obecnie nie ma tu dostępnych produktów.','Nie udało się wczytać produktów. Spróbuj ponownie.','Spróbuj ponownie','Poprzednie produkty','Następne produkty','{n} z {total}','Krótko o produkcie','Otwórz stronę produktu','Otwórz kolekcję w nowej karcie','Wczytaj więcej produktów','Ceny i dostępność mogą się zmienić. Pełne informacje znajdziesz na stronie produktu.'],
    sv:['Upptäck i chatten','Ta god tid på dig. Svep över bilden eller använd pilarna – dina råd finns kvar här.','Borstar','Primers','Singelskuggor','Tillbaka till råden','Laddar produkter …','Inga produkter är tillgängliga här just nu.','Produkterna kunde inte laddas. Försök igen.','Försök igen','Föregående produkter','Nästa produkter','{n} av {total}','Kort produktinformation','Öppna produktsidan','Öppna kollektionen i en ny flik','Ladda fler produkter','Priser och tillgänglighet kan ändras. Fullständig information finns på produktsidan.'],
    fi:['Tutustu chatissa','Katsele rauhassa. Pyyhkäise kuvaa tai käytä nuolia – neuvot säilyvät täällä.','Siveltimet','Pohjustajat','Yksittäiset sävyt','Takaisin neuvoihin','Ladataan tuotteita…','Täällä ei ole juuri nyt saatavilla olevia tuotteita.','Tuotteiden lataus epäonnistui. Yritä uudelleen.','Yritä uudelleen','Edelliset tuotteet','Seuraavat tuotteet','{n} / {total}','Tuotetiedot lyhyesti','Avaa tuotesivu','Avaa kokoelma uuteen välilehteen','Lataa lisää tuotteita','Hinnat ja saatavuus voivat muuttua. Täydelliset tiedot löytyvät tuotesivulta.'],
    nl:['Ontdek in de chat','Neem je tijd. Veeg over de afbeelding of gebruik de pijlen – je advies blijft hier.','Kwasten','Primers','Losse oogschaduws','Terug naar je advies','Producten laden …','Er zijn hier nu geen producten beschikbaar.','De producten konden niet worden geladen. Probeer het opnieuw.','Opnieuw proberen','Vorige producten','Volgende producten','{n} van {total}','Korte productinformatie','Open productpagina','Open collectie in een nieuw tabblad','Meer producten laden','Prijzen en beschikbaarheid kunnen veranderen. De productpagina bevat alle informatie.']
  };
  const language = root.dataset.locale?.split('-')[0];
  const t = copy[language] || copy.en;
  const stock = {de:'Zurzeit ausverkauft',en:'Currently sold out',fr:'Actuellement épuisé',it:'Al momento esaurito',es:'Agotado actualmente',pl:'Obecnie wyprzedane',sv:'Tillfälligt slutsåld',fi:'Tällä hetkellä loppuunmyyty',nl:'Momenteel uitverkocht'};
  const soldOut = stock[language] || stock.en;
  const q = name => view.querySelector('[data-advisor-shop-' + name + ']');
  const categories = ['pinsel','primer','single-eyeshadows'];
  const tabs = [...view.querySelectorAll('[data-advisor-shop-category]')];
  q('title').textContent = t[0]; q('intro').textContent = t[1];
  q('back').textContent = '← ' + t[5]; q('tabs').setAttribute('aria-label',t[0]);
  tabs.forEach((button,index) => { button.textContent = t[2 + index]; });
  q('prev').setAttribute('aria-label',t[10]); q('next').setAttribute('aria-label',t[11]);
  q('collection').textContent = t[15];
  const states = new Map();
  let category = categories[0], origin = null, active = false, controller = null, pendingState = null;
  const cancel = () => {
    controller?.abort();
    if (pendingState) pendingState.busy = false;
    controller = null; pendingState = null;
  };
  const base = new URL(root.dataset.shopRoot || '/',location.origin);
  if (base.origin !== location.origin) return;
  const prefix = base.pathname.replace(/\/?$/,'/');
  const preview = new URLSearchParams(location.search).get('preview_theme_id');
  const preservePreview = url => {
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id',preview);
    return url;
  };
  const collectionUrl = key => new URL(prefix + 'collections/' + key,location.origin);
  const requestUrl = (key,value) => {
    const url = value ? new URL(value,location.origin) : collectionUrl(key);
    if (url.origin !== location.origin || url.pathname !== collectionUrl(key).pathname) throw Error('route');
    url.searchParams.set('section_id','monolith-advisor-products');
    url.searchParams.delete('filter.v.availability');
    return preservePreview(url);
  };
  const getState = key => {
    if (!states.has(key)) states.set(key,{items:[],index:0,next:null,loaded:false,busy:false,error:false,time:0});
    return states.get(key);
  };
  const productUrl = value => {
    try {
      const url = new URL(value,location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)) return null;
      return preservePreview(url).href;
    } catch (_) { return null; }
  };
  const render = () => {
    const state = getState(category);
    const item = state.items[state.index];
    const visible = state.items.slice(state.index,state.index + 2);
    tabs.forEach(tab => { tab.setAttribute('aria-pressed',String(tab.dataset.advisorShopCategory === category)); });
    q('stage').replaceChildren();
    q('stage').setAttribute('aria-busy',String(state.busy));
    q('status').textContent = state.busy ? t[6] : state.error ? t[8] : !item ? t[7] : '';
    q('status').hidden = !q('status').textContent;
    q('retry').hidden = !state.error && !(state.next && !item);
    q('retry').textContent = state.error ? t[9] : t[16];
    q('retry').disabled = state.busy;
    q('nav').hidden = !item;
    q('prev').disabled = state.busy || state.index === 0;
    q('next').disabled = state.busy || (state.index + 2 >= state.items.length && !state.next);
    q('next').setAttribute('aria-label',state.index + 2 >= state.items.length && state.next ? t[16] : t[11]);
    q('position').textContent = t[12].replace('{n}',visible.length > 1 ? (state.index + 1) + '–' + (state.index + visible.length) : String(state.index + 1)).replace('{total}',String(state.items.length) + (state.next ? '+' : ''));
    const browse = collectionUrl(category);
    q('collection').href = preservePreview(browse).href;
    if (!item) return;
    for (const item of visible) {
    const card = document.createElement('article'); card.className = 'mono-advisors__shop-card';
    if (item.image) {
      const image = document.createElement('img'); image.src = item.image; image.alt = item.title;
      image.width = 240; image.height = 180; image.loading = 'lazy'; image.draggable = false;
      let start = null;
      image.addEventListener('touchstart',event => {
        const touch = event.touches.length === 1 ? event.touches[0] : null;
        start = touch ? {x:touch.clientX,y:touch.clientY} : null;
      },{passive:true});
      image.addEventListener('touchend',event => {
        const touch = event.changedTouches[0];
        if (start && touch) {
          const dx = touch.clientX - start.x, dy = touch.clientY - start.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) move(dx < 0 ? 1 : -1);
        }
        start = null;
      },{passive:true});
      image.addEventListener('touchcancel',() => { start = null; },{passive:true});
      card.append(image);
    }
    const vendor = document.createElement('p'); vendor.className = 'mono-advisors__shop-vendor'; vendor.textContent = item.vendor;
    const title = document.createElement('h4'); title.textContent = item.title;
    const money = document.createElement('p'); money.className = 'mono-advisors__shop-price'; money.textContent = item.money;
    card.append(vendor,title,money);
    if (!item.available) {
      const availability = document.createElement('p'); availability.className = 'mono-advisors__shop-stock'; availability.textContent = soldOut; card.append(availability);
    }
    if (item.description) {
      const details = document.createElement('details'); const summary = document.createElement('summary'); summary.textContent = t[13];
      const text = document.createElement('p'); text.textContent = item.description; details.append(summary,text); card.append(details);
    }
    const link = document.createElement('a'); link.className = 'mono-advisors__application-link';
    link.href = item.url; link.textContent = t[14]; link.target = '_blank'; link.rel = 'noopener noreferrer';
    card.append(link); q('stage').append(card);
    root.dispatchEvent(new CustomEvent('monolith:product-controls',{detail:{container:card,url:item.url,available:item.available}}));
    }
  };
  const load = async (key,more = false) => {
    const state = getState(key);
    if (state.busy) return;
    cancel();
    const request = new AbortController(); controller = request; pendingState = state; state.request = request;
    const timeout = setTimeout(() => request.abort(),10000);
    state.busy = true; state.error = false; if (active && category === key) render();
    try {
      let next = more ? state.next : null;
      let pages = 0;
      const items = more ? state.items.slice() : [];
      const seen = new Set(items.map(item => item.id));
      const startLength = items.length;
      do {
        const response = await fetch(requestUrl(key,next).href,{credentials:'same-origin',signal:request.signal});
        if (!response.ok) throw Error('unavailable');
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        if (request.signal.aborted) throw Error('aborted');
        const result = html.querySelector('[data-advisor-product-results]');
        if (!result) throw Error('invalid_response');
        for (const node of result.querySelectorAll('[data-advisor-product-data]')) {
          const id = node.dataset.id, url = productUrl(node.dataset.url);
          if (!/^\d+$/.test(id || '') || seen.has(id) || !url) continue;
          const title = node.querySelector('[data-title]')?.textContent?.trim();
          if (!title) continue;
          let image = null;
          try {
            const src = node.querySelector('img')?.getAttribute('src');
            if (!src) throw Error('no_image');
            const candidate = new URL(src,location.origin);
            if (candidate.protocol === 'https:' && (candidate.origin === location.origin || candidate.hostname === 'cdn.shopify.com')) image = candidate.href;
          } catch (_) {}
          items.push({id,url,title,available:node.dataset.available === 'true',vendor:node.querySelector('[data-vendor]')?.textContent || '',money:node.querySelector('[data-money]')?.textContent || '',description:node.querySelector('[data-description]')?.textContent || '',image});
          seen.add(id);
        }
        next = result.dataset.next || null;
        if (next) next = requestUrl(key,next).href;
        pages++;
      } while (next && items.length === startLength && pages < 3);
      state.items = items; state.next = next; state.loaded = true; state.time = Date.now();
      state.index = more && items.length > startLength ? startLength : Math.min(state.index,Math.max(0,items.length - 1));
    } catch (_) {
      if (controller === request) state.error = true;
    } finally {
      clearTimeout(timeout); if (state.request === request) state.busy = false;
      if (controller === request) { controller = null; pendingState = null; if (active && category === key) render(); }
    }
  };
  const choose = key => {
    category = key;
    cancel();
    const state = getState(key);
    render();
    if (!state.loaded || Date.now() - state.time > 300000) load(key);
  };
  async function move(step) {
    const state = getState(category);
    if (state.busy) return;
    if (step > 0 && state.index + 2 >= state.items.length && state.next) await load(category,true);
    else if (step < 0 && state.index > 0) { state.index = Math.max(0,state.index - 2); render(); }
    else if (step > 0 && state.index + 2 < state.items.length) { state.index += 2; render(); }
  }
  q('prev').addEventListener('click',() => move(-1)); q('next').addEventListener('click',() => move(1));
  q('retry').addEventListener('click',() => load(category,getState(category).loaded && !!getState(category).next));
  tabs.forEach(tab => tab.addEventListener('click',() => choose(tab.dataset.advisorShopCategory)));
  q('back').addEventListener('click',() => {
    const destination = origin; root.dispatchEvent(new CustomEvent('monolith:navigate',{detail:{kind:'choice',key:destination?.name || 'pair'}}));
    destination?.source?.focus({preventScroll:true});
    if (destination) root.querySelector('dialog').scrollTop = destination.scroll;
  });
  root.addEventListener('monolith:view',event => {
    active = event.detail.name === 'shop';
    if (!active) { cancel(); }
  });
  root.addEventListener('click',event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || view.contains(link)) return;
    let target;
    try { target = new URL(link.href); } catch (_) { return; }
    const key = categories.find(value => target.origin === location.origin && target.pathname === collectionUrl(value).pathname);
    if (!key) return;
    event.preventDefault();
    origin = {name:root.dataset.advisorScreen || link.closest('[data-advisor-view]')?.dataset.advisorView,source:link,scroll:root.querySelector('dialog').scrollTop};
    root.dispatchEvent(new CustomEvent('monolith:navigate',{detail:{kind:'choice',key:'shop'}}));
    if (root.dataset.advisorScreen === 'shop') choose(key);
  });
})();

